<div [class]="mode">
  <form *ngIf="formGroup && mode == 'form'" [formGroup]="formGroup">
    <div *ngFor="let field of formConfig">
      <kendo-textbox
        *ngIf="field.type === 'input'"
        [formControlName]="field.key"
        [placeholder]="field.label"
        [required]="field.required ?? false"
        class="w-100 mb-3"
      ></kendo-textbox>

      <!-- Currency (use kendo-numerictextbox) -->
      <kendo-numerictextbox
        *ngIf="field.type === 'currency'"
        [formControlName]="field.key"
        [placeholder]="field.label"
        [required]="field.required ?? false"
        class="w-100 mb-3"
      ></kendo-numerictextbox>

      <!-- Textarea -->
      <kendo-textarea
        *ngIf="field.type === 'textarea'"
        [formControlName]="field.key"
        [placeholder]="field.label"
        [required]="field.required ?? false"
        class="w-100 mb-3"
      ></kendo-textarea>

      <!-- Select -->
      <kendo-dropdownlist
        *ngIf="field.type === 'select'"
        [formControlName]="field.key"
        [data]="isArray(field.options) ? field.options : (field.options | async) || []"
        [textField]="'label'"
        [valueField]="'value'"
        [required]="field.required ?? false"
        [defaultItem]="{ label: 'Select...', value: null }"
        class="w-100 mb-3"
      ></kendo-dropdownlist>
    </div>
  </form>
</div>
